import type { Pagination, ProductSubtype } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'products/subtypes';

export function getProductSubtypes(query?: ProductSubtype.SearchQuery) {
    return api.get<Pagination<ProductSubtype>>(rootPath, query);
}

export function getProductSubtype(id: number) {
    return api.get<ProductSubtype.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postProductSubtype(data: ProductSubtype.CreateRequest) {
    return api.post<ProductSubtype>(rootPath, data);
}

export function putProductSubtype(
    id: number,
    data: ProductSubtype.UpdateRequest
) {
    return api.put<ProductSubtype>(`${rootPath}/${id}`, data);
}

export function deleteProductSubtype({ id }: ProductSubtype.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
